module.exports = __webpack_public_path__ + "img/yscj.1eef647e.png";